import CarElectricStationsIcon from './component'

export default CarElectricStationsIcon
